<template>
  <div class="stagnation-modal" @touchstart="clickApp">
    <div class="operating-hint">
      <p class="title">{{ $t("public.study") }}</p>
      <img src="@/assets/img/audio-footer/foolproof.png" />
      <p class="warring-hint">{{ $t("public.click") }}</p>
      <p class="time-hint" v-if="$i18n.locale == 'zh'">
        否则 <slot></slot>后退出课件!
      </p>
      <p class="time-hint" v-else>
        or you will exit the software in<slot></slot>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    clickApp() {
      this.$emit("touchstart");
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/sass/color.less";

.stagnation-modal {
  position: fixed;
  top: 0;
  height: 100vh;
  width: 100%;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  font-size: 0.26rem;
  .operating-hint {
    width: 6.73rem;
    height: 4.63rem;
    background: white;
    border-radius: 0.1rem;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    overflow: hidden;
    img {
      width: 3rem;
      margin: 0.5rem auto 0.2rem;
    }
    .title {
      font-size: 0.24rem;
      font-weight: 600;
      line-height: 0.7rem;
      background: #f2f2f2;
    }
    .warring-hint {
      color: @unPassColor;
      font-size: 0.34rem;
      font-weight: 600;
    }
    .time-hint {
      margin-top: 0.2rem;
      color: #999;
      span {
        .warring-hint;
      }
    }
  }
}
</style>
